// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

//---- jQuery(UI) ----
import './src/jquery'

//---- JavintoAppPages
require("./packs/content/content_assets")
require("./packs/content/content_pages")

require("./packs/global");
require("./packs/global_bootstrap");
require("./packs/stream_actions");

//---- Conditionals
import * as conditionals from "./packs/conditionals.js"
window.addEventListener("turbo:load", () => {conditionals.bind(document)});

//---- pidwijzer.nl ----
require("./packs/modals");
require("./pid/tab");
require("./pid/pid_result");